const storeOAuthStateInLocalStorage = (oAuthState) => {
  localStorage.setItem('anova_o_auth_state', oAuthState)
}

export default storeOAuthStateInLocalStorage
